import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../api";

// UI
import { HeaderPage, Table, Pagination, Button } from "../../ui";
import { sumFormat } from "../../lib/helpers/strings";

class FilialsListPage extends Component {
  state = {
    titleHeader: "Филиалы",
    loading: true,
    filials: {
      list: [],
      meta: {
        page: 0,
        pages: 0,
        count: 0,
        perPage: 0,
        fromRecord: 0,
        toRecord: 0
      }
    },
    query: {
      page: 0
    }
  };

  async componentDidMount() {
    // const parsedQuery = queryString.parse(window.location.search);
    // const page = (parsedQuery && parsedQuery.page) || 0;
    let page = 0;

    // this.setState({
    //   query: {
    //     page
    //   }
    // });

    const { data, meta } = await API.filials.getList({ page }, { full: true });

    this.setState({
      loading: false,
      filials: {
        list: data,
        meta
      }
    });
  }

  onChangedPagination = async page => {
    this.setState({
      loading: true
    });

    const { data, meta } = await API.filials.getList({ page }, { full: true });

    this.setState({
      loading: false,
      filials: {
        list: data,
        meta
      },
      query: {
        page
      }
    });
  };

  getTableColumns = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => this.state.filials.meta.fromRecord + i,
        footer: {}
      },
      {
        title: "Название",
        render: ({ item }) => {
          return <Link to={`/filials/${item._id}`}>{item.name}</Link>;
        },
        footer: { title: "Итого", colSpan: 2 }
      },
      { title: "Местоположение", suffix: "филиала", field: "city" },
      {
        title: "начало дня",
        prefix: "касса на",
        suffix: "тенге",
        text: "right",
        field: "cash_desk_start_day",
        render: ({ field }) => sumFormat(field),
        footer: {
          sum: true,
          render: ({ result }) => sumFormat(result)
        }
      },
      // {title: 'в течении дня', prefix: 'касса изменилась', suffix: 'тенге', text: 'right'},
      {
        title: "конец дня",
        prefix: "касса на",
        suffix: "тенге",
        text: "right",
        field: "cash_desk",
        render: ({ field }) => sumFormat(field),
        footer: {
          sum: true,
          render: ({ result }) => sumFormat(result)
        }
      }
    ];
  };

  render() {
    const { filials } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage title={this.state.titleHeader} count={filials.meta.count}>
          <Button type="as" as={Link} to="/filials/create" theme="success">
            Создать
          </Button>
        </HeaderPage>

        <Table
          columns={this.getTableColumns()}
          data={filials.list}
          loading={this.state.loading}
        />

        <Pagination
          linkPages={"/filials"}
          linkPagesQuery={false}
          count={filials.meta.count}
          page={filials.meta.page}
          pages={filials.meta.pages}
          onClick={this.onChangedPagination}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(FilialsListPage));
